<template>
  <span class="flex flex-1 items-center" :class="{ 'text-right flex-row-reverse': right }" :data-user-id="user.id">
    <img
      v-if="showAvatar && image"
      :src="image"
      alt=""
      class="avatar"
      :class="{ 'ml-4': right, 'mr-4': !right }"
      v-tooltip="tooltip"
    />
    <Icon
      v-else-if="showAvatar"
      :name="icon"
      class="md-36 md-dark md-inactive"
      :class="{ 'ml-4': right, 'mr-4': !right }"
    />
    <span class="flex flex-col">
      <span class="flex items-center gap-x-2">
        <strong class="text-base">{{ name }}</strong>
        <span v-if="showCompany && showContact && company" class="text-sm">
          {{ company.name }}
        </span>

        <span v-if="user.adminRole" class="mdl-label">
          <Icon name="security" class="text-[12px]" />
          {{ user.adminRole.label }}
        </span>

        <slot name="after-name" />
      </span>

      <span v-if="showContact || (showCompany && company)" class="text-sm" :class="{ 'text-right': right }">
        <span v-if="showContact && user.email" :class="{ 'ml-2': right, 'mr-2': !right }">
          <Icon v-if="showIcon" name="email" small />
          {{ user.email }}
        </span>
        <span v-if="showContact && user.mobile" :class="{ 'ml-2': right, 'mr-2': !right }">
          <Icon v-if="showIcon" name="phone" small />
          {{ formatPhone(user.mobile) }}
        </span>
        <span v-if="!showContact && showCompany && company" :class="{ 'ml-2': right, 'mr-2': !right }">
          {{ company.name }}
        </span>
      </span>
    </span>
  </span>
</template>

<script>
import Icon from '@component/Icon.vue'
import { userFullname, formatPhone } from '@/munio/utils/index.js'
import tooltip from '@directive/tooltip'

export default {
  components: {
    Icon,
  },
  props: {
    user: { type: Object, required: true },
    contact: { type: Boolean },
    icon: { type: String, default: 'account_circle' },
    withoutAvatar: { type: Boolean },
    withoutIcons: { type: Boolean },
    right: { type: Boolean },
    showCompany: { type: Boolean, default: true },
  },
  directives: {
    tooltip: tooltip,
  },
  computed: {
    image() {
      if (!this.user.avatar) {
        return undefined
      }

      if (typeof this.user.avatar === 'string') {
        return this.user.avatar
      }

      return this.user.avatar.url
    },
    name() {
      return userFullname(this.user)
    },
    company() {
      return this.user.company || this.user.employer
    },
    showAvatar() {
      return !this.withoutAvatar
    },
    showContact() {
      return this.contact && this.user.email !== this.name
    },
    showIcon() {
      return !this.withoutIcons
    },
    tooltip() {
      if (window.can('munio') && this.user.id) {
        return `User ID: ${this.user.id}`
      }

      return undefined
    },
  },
  methods: {
    formatPhone,
  },
}
</script>
